import React from 'react';
import { SectionLayout } from '@/components/section-layout';

export function TakeoffPage() {
  return (
    <SectionLayout title="Takeoff">
      {/* Takeoff content will go here */}
    </SectionLayout>
  );
} 